import { USER_PLAN } from '@/constant/storage';
import { SearchStatusFollowEnum } from '../notification.interface';

export enum EMemberTabSectionKey {
  Introduction = 'Member_Introduction',
  MemberList = 'Member_MemberList',
}

export interface IMemberTabIntroduceSection {
  image: string;
}

export type TEnterpriseProfileMemberTabSectionElements =
  IMemberTabIntroduceSection;

export type TEnterpriseProfileMemberTabSection = {
  sectionName: string;
  sectionKey: EMemberTabSectionKey;
  elements?: TEnterpriseProfileMemberTabSectionElements;
  isActive: boolean;
}[];

export interface IEnterpriseProfileEachMemberData {
  slug: string;
  ownerId: number;
  avatar: string;
  userName: string;
  academicRank: string;
  userPlan: USER_PLAN;
  followStatus: SearchStatusFollowEnum;
  hasBlueTick: boolean;
}
